import { Field, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'

@ObjectType()
@InputType('StripePaymentInput')
export class StripePayment extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  sessionId: string

  @Field(() => String)
  @Prop({ type: String })
  paymentIntent: string

  @Field(() => String)
  @Prop({ type: String })
  source: string

  @Field(() => String)
  @Prop({ type: String })
  paymentId: string

  @Field(() => String)
  metadata: string
}
